import {usualVisitorSignEnter, usualVisitorSignLeave} from "@/api/record-api";

export const usual_visitor_sign_mixin = {

    data() {
        return {}
    },

    methods: {

        // 检查是否常访人员
        checkIsVisitorUsual(visitor) {
            if (!visitor || visitor.type !== 'usual' || !visitor.usualTimeLimit) {
                return false
            }
            const extInfo = JSON.parse(visitor.usualTimeLimit)
            // none 表示不限制
            if (extInfo.type === "none") {
                return true;
            }
            // 限制时间段
            if (extInfo.type === "have") {
                const now = new Date();
                const nowTime = now.getTime();
                const startTime = new Date(extInfo.beginTime).getTime();
                const endTime = new Date(extInfo.endTime).getTime();
                if (nowTime >= startTime && nowTime <= endTime) {
                    return true;
                }
            }
            return false;
        },

        // 常访人员签入逻辑
        doUsualSignEnter(visitor, deviceId, areaId, remark, imageBase64, icCompareResult, icCompareScore, enterCarNum, enterCardNo, enterGuardName) {
            let param = {
                visitorCode: visitor.code,
                enterDeviceId: deviceId,
                enterAreaId: areaId,
                enterCardNo: visitor.cardNo,
            }
            if (enterCarNum) {
                param.enterCarNum = enterCarNum
            }
            if (enterGuardName) {
                param.enterGuardName = enterGuardName
            }
            if (enterCardNo) {
                param.enterCardNo = enterCardNo
            }
            if (remark) {
                param.comments = remark
            }
            // if (imageBase64) {
            //     let time = new Date().getTime()
            //     let photoKey =  "usualSign/photo/" + visitor.code + "-" + time + ".jpg"
            //     uploadBase64File(imageBase64, photoKey)
            //
            //     param.enterPhoto = photoKey
            // }
            if (icCompareResult) {
                param.icCompareResult = icCompareResult
            }
            if (icCompareScore) {
                param.icCompareScore = icCompareScore
            }
            console.log("usualVisitorSignEnter param:: " + JSON.stringify(param))
            usualVisitorSignEnter(param).then(({data}) => {
                if (data.code === 200) {
                    console.log("usualVisitorSignEnter :: " + JSON.stringify(data))
                    this.notifyUsualVisitorSignEnterResult(visitor, true, "签到成功", data.data)
                    this.doPrint()
                } else {
                    console.log("usualVisitorSignEnter :: " + data.code + " :: " + data.msg)
                    this.notifyUsualVisitorSignEnterResult(visitor, false, "签到失败", null)
                }
            }).catch((err) => {
                console.log("usualVisitorSignEnter", err)
                this.notifyUsualVisitorSignEnterResult(visitor, false, "签到失败", null)
            })

        },

        // 常访人员签出逻辑
        doUsualSignLeave(visitor, deviceId, areaId, recordId) {
            let postData = {
                recordIds: [recordId],
                leaveDeviceId: deviceId,
                leaveAreaId: areaId,
            }
            usualVisitorSignLeave(postData).then(({data}) => {
                if (data.code === 200) {
                    this.notifyUsualVisitorSignLeaveResult(visitor, true, "签离成功")
                } else {
                    this.notifyUsualVisitorSignLeaveResult(visitor, false, "签离失败")
                }
            }).catch(() => {
                this.notifyUsualVisitorSignLeaveResult(visitor, false, "签离失败")
            })

        },

        notifyUsualVisitorSignEnterResult(visitor, isSuccess, msg, applyInfo) {
            if (isSuccess) {
                this.usualVisitorJumpToPrintPage(visitor, msg, applyInfo)
            } else {
                this.notify = {title: "签到结果", show: true, success: false, msg: "签到失败",}
            }
        },

        // qrText(visitorCode) {
        //     let type = "visitor"
        //     let code = visitorCode
        //     let time = new Date()
        //
        //     let qr_text = {
        //         "type": type,
        //         "code": code,
        //         "time": time
        //     }
        //     console.log("解密后的内容", aesDec(aesEnc(JSON.stringify(qr_text))))
        //     console.log("content => ", aesEnc(JSON.stringify(qr_text)))
        //
        //     return aesEnc(JSON.stringify(qr_text))
        // },

        getFormatedTime() {
            let dat = new Date()
            let year = dat.getFullYear();
            let mon = (dat.getMonth() + 1) < 10 ? "0" + (dat.getMonth() + 1) : dat.getMonth() + 1;
            let data = dat.getDate() < 10 ? "0" + (dat.getDate()) : dat.getDate();
            let hour = dat.getHours() < 10 ? "0" + (dat.getHours()) : dat.getHours();
            let min = dat.getMinutes() < 10 ? "0" + (dat.getMinutes()) : dat.getMinutes();

            return year + "-" + mon + "-" + data + " " + hour + ":" + min;
        },

        usualVisitorJumpToPrintPage(visitor, msg, applyInfo) {
            this.notify = {title: "签到结果", show: true, success: true, msg: "签到成功",}
        },

        notifyUsualVisitorSignLeaveResult(visitor, isSuccess, msg) {
            if (isSuccess) {
                this.notify = {title: "签离结果", show: true, success: true, msg: "签离成功",}
            } else {
                this.notify = {title: "签离结果", show: true, success: false, msg: "签离失败",}
            }
        }
    }
}
